'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressList = function AddressList(_ref) {
    var addresses = _ref.addresses,
        selectedDeliveryAddressIdx = _ref.selectedDeliveryAddressIdx,
        onDeliverySelectionChanged = _ref.onDeliverySelectionChanged,
        handleRemoveAddress = _ref.handleRemoveAddress,
        isAccount = _ref.isAccount;
    return _react2.default.createElement(
        'div',
        null,
        addresses.map(function (address, idx, array) {

            var isChecked = false;

            if (selectedDeliveryAddressIdx !== '') {
                isChecked = selectedDeliveryAddressIdx == idx;
            }

            return _react2.default.createElement(
                'li',
                { key: 'ad' + idx },
                _react2.default.createElement(
                    'div',
                    { className: 'radio newAddressItem-radio', key: 'div' + idx },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'addi' + idx, className: 'container-radio address-width-ctrl delivery-address-width-ctrl' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'b',
                                { className: 'list-group-item-heading cart-header' },
                                (address.name || address.firstName) + ': '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'text-secondary-light' },
                                address.addLine1,
                                ' ',
                                address.addLine2,
                                ', ',
                                address.city
                            )
                        ),
                        _react2.default.createElement('input', {
                            id: 'addi' + idx,
                            type: 'radio',
                            name: 'addRadio',
                            value: idx,
                            checked: isChecked,
                            onChange: onDeliverySelectionChanged
                        }),
                        _react2.default.createElement('span', { className: 'checkmark-radio' })
                    )
                )
            );
        })
    );
};

exports.default = AddressList;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/address/AddressList.jsx
// module id = 493
// module chunks = 0